module.exports = __webpack_public_path__ + "img/hbk-arquitectura.4bf5b16e.png";